import { ReactElement, useCallback } from 'react';
import styles from '@/styles/pages/home/economy-page.module.less';
import Image from '@/components/LocalImage';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { useTranslation } from '@/services';
import { mergeClasses } from '@/utils';

const ShowOneTab = (): ReactElement => {
    const toAicadeGalaxyToken = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://docs.aicadegalaxy.com/white-paper/economics/aicade-galaxy-token';
        }
    }, []);
    const { t } = useTranslation('home', 'home.economy');
    return (
        <div className={mergeClasses(styles['statistics-board'])}>
            <div className={styles['tag-bg']}>
                <Image type="png" name="three_tag_bg_image" dir="/images/home"></Image>
            </div>
            <div className={styles['tag-content']}>
                <div className={styles['tag-conten-title']}>{t('full-disclosure-title')}</div>
                <div className={styles['tag-conten-value']}>{t('full-disclosure-value')}</div>
            </div>
            <div onClick={() => toAicadeGalaxyToken()} className={styles['tab-btn']}>
                {t('view-supply-info')}
            </div>
            <div className={styles['chart']}>
                <Image name="chart-one" className={styles['chart-img']} type="svg" dir="/images/home"></Image>
            </div>
        </div>
    );
};

const ShowOneTwo = (): ReactElement => {
    const { t } = useTranslation('home', 'home.economy');
    const avoidBecomingAnAirCoin = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://docs.aicadegalaxy.com/white-paper/economics/avoid-becoming-an-air-coin';
        }
    }, []);
    return (
        <div className={styles['statistics-board']}>
            <div className={styles['tag-bg']}>
                <Image type="png" name="three_tag_bg_image2" dir="/images/home"></Image>
            </div>
            <div className={styles['tag-content']}>
                <div className={styles['tag-conten-title']}>{t('full-return-title')}</div>
                <div className={styles['tag-conten-value']}>{t('full-return-value')}</div>
            </div>
            <div onClick={() => avoidBecomingAnAirCoin()} className={styles['tab-btn']}>
                {t('view-supply-info')}
            </div>
            <div className={styles['chart']}>
                <Image name="chart-two" className={styles['chart-img']} type="svg" dir="/images/home"></Image>
            </div>
        </div>
    );
};

const ShowOneThree = (): ReactElement => {
    const { t } = useTranslation('home', 'home.economy');
    const earlyParticipationRewards = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://docs.aicadegalaxy.com/white-paper/economics/early-participation-rewards';
        }
    }, []);
    return (
        <div className={styles['statistics-board']}>
            <div className={styles['tag-bg']}>
                <Image type="png" name="three_tag_bg_image3" dir="/images/home"></Image>
            </div>
            <div className={styles['tag-content']}>
                <div className={styles['tag-conten-title']}>{t('early-participation-title')}</div>
                <div className={styles['tag-conten-value']}>{t('early-participation-value')}</div>
            </div>
            <div onClick={() => earlyParticipationRewards()} className={styles['tab-btn']}>
                {t('view-supply-info')}
            </div>
            <div className={styles['chart']}>
                <Image name="chart-three" className={styles['chart-img']} type="svg" dir="/images/home"></Image>
            </div>
        </div>
    );
};

const ShowFourTab = (): ReactElement => {
    const { t } = useTranslation('home', 'home.economy');
    const crowdfunding = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://docs.aicadegalaxy.com/white-paper/wide-participation/crowdfunding';
        }
    }, []);
    return (
        <div className={styles['statistics-board']}>
            <div className={styles['tag-bg']}>
                <Image type="png" name="three_tag_bg_image4" dir="/images/home"></Image>
            </div>
            <div className={styles['tag-content']}>
                <div className={styles['tag-conten-title']}>{t('pledge-profit-title')}</div>
                <div className={styles['tag-conten-value']}>{t('pledge-profit-value')}</div>
            </div>
            <div onClick={() => crowdfunding()} className={styles['tab-btn']}>
                {t('view-supply-info')}
            </div>
            <div className={styles['chart']}>
                <Image name="chart-four" className={styles['chart-img']} type="svg" dir="/images/home"></Image>
            </div>
        </div>
    );
};

const ShowFiveTab = (): ReactElement => {
    const { t } = useTranslation('home', 'home.economy');
    const zeroLiquidationRiskPledge = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://docs.aicadegalaxy.com/white-paper/economics/zero-liquidation-risk-pledge';
        }
    }, []);
    return (
        <div className={styles['statistics-board']}>
            <div className={styles['tag-bg']}>
                <Image type="png" name="three_tag_bg_image5" dir="/images/home"></Image>
            </div>
            <div className={styles['tag-content']}>
                <div className={styles['tag-conten-title']}>{t('zero-clearing-title')}</div>
                <div className={styles['tag-conten-value']}>{t('zero-clearing-value')}</div>
            </div>
            <div onClick={() => zeroLiquidationRiskPledge()} className={styles['tab-btn']}>
                {t('view-supply-info')}
            </div>
            <div className={styles['chart']}>
                <Image name="chart-five" className={styles['chart-img']} type="svg" dir="/images/home"></Image>
            </div>
        </div>
    );
};

const EconomyPage = (): ReactElement => {
    const { t } = useTranslation('home', 'home.economy');
    return (
        <div className={styles['content']}>
            <div>
                <ul>
                    <li>
                        <div className={styles['price-board']}>
                            <div className={styles['p-value']}>{t('mint-trade')}</div>
                            <div>
                                <div className={styles['price']}>
                                    <div>
                                        <div className={styles['title-value']}>{t('pledge-yield')}</div>
                                        <div className="mt-2">
                                            <Image name="58-number" dir="/images/home" type="svg"></Image>
                                        </div>
                                    </div>
                                    <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                                    <div>
                                        <div className={styles['title-value']}>{t('alcade-token')}</div>
                                        <div className="mt-2">
                                            <Image name="1-53" dir="/images/home" type="svg"></Image>
                                        </div>
                                    </div>
                                    <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                                    <div>
                                        <div className={styles['title-value']}>{t('floor-price')}</div>
                                        <div className="mt-2">
                                            <Image name="price" dir="/images/home" type="svg"></Image>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles['mint-btn']}>
                                <Link to="/admin/mint">
                                    <Button className={styles['mint']}>{t('btn-mint')}</Button>
                                </Link>
                                <Link to="/admin/mint">
                                    <Button className={styles['umint']}>{t('btn-umint')}</Button>
                                </Link>
                            </div>
                        </div>
                    </li>
                </ul>

                {/**移动端价格展示区域 */}
                <div className={styles['mini-price']}>
                    <div>
                        <div className={styles['title-value']}>{t('pledge-yield')}</div>
                        <div className={styles['label-price']}>
                            <div className={styles['price-item']}>
                                <div>58</div>
                                <div className={styles['unit']}>%</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                    <div>
                        <div className={styles['title-value']}>{t('alcade-token')}</div>
                        <div className={styles['label-price']}>
                            <div className={styles['price-item']}>
                                <div className={styles['unit']}>$</div>
                                <div>1.53</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                    <div>
                        <div className={styles['title-value']}>{t('floor-price')}</div>
                        <div className={styles['label-price']}>
                            <div className={styles['price-item']}>
                                <div className={styles['unit']}>$</div>
                                <div>0.8</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/**移动端展示 */}
                <div className={styles['tabs']}>
                    <ShowOneTab></ShowOneTab>
                    <ShowOneTwo></ShowOneTwo>
                    <ShowOneThree></ShowOneThree>
                    <ShowFourTab></ShowFourTab>
                    <ShowFiveTab></ShowFiveTab>
                </div>
            </div>
        </div>
    );
};

export default EconomyPage;
